import { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import {
   RegisterCards,
   SponsorSectionTest,
   StatsBanner,
   VideoSection,
   TracksWeb,
   NavBarFinal,
   TestimonialCarouselNew,
   Investors,
   LogoCarouselNew,
   FooterFinal,
   NominateCards
} from "../components/index";


export const HomeTest = () => {
   document.title = "Florida Venture Summit | Overview";


   const [finishedLoading, setFinishedLoading] = useState(false);
   window.onload = function () {
      setFinishedLoading(true);
   }
   useEffect(() => {
      if (document.readyState === "complete") {
         setFinishedLoading(true);
      }
   }, [])


   return (
      <div style={{ backgroundColor: 'black !important' }}>
         <NavBarFinal />

         <Container
            fluid
            style={{
               height: "auto",
               padding: 0,
               margin: 0,
               position: 'relative',
               backgroundColor: 'black',
            }}
         >
            <img
               alt='Overview'
               src={window.innerWidth < 769 ? "./assets/events/fvs22/Overview Banner Image (7).png" : "./assets/events/fvs22/Overview Banner Image (4).jpg"}
               id="banner-img"
               loading="eager"
               style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "auto",
                  minHeight: window.innerWidth > 1200 && "50vh"
               }}
            />


            {window.innerWidth > 769 && <StatsBanner />}

            {/* {window.innerWidth < 769 ? <img src="./assets/events/fvs22/numbers banner.png"
          style={{
            width: "95%",
            display: "block",
            margin: " 0 auto",
            position: "relative",
            bottom: "10px",
            zIndex: "2",
            backgroundColor: "#3a30"
          }} /> : <StatsBanner />} */}
            {/* <span
          className="banner-text"
          style={{
            position: "absolute",
            color: "white",
            fontFamily: "Roboto Condensed, sans-serif !important",
            fontSize: "2.5rem",
            fontWeight: "900",
            top: window.innerWidth< 900 ? "12.5%" : "27.5%",
            textShadow: "2px 2px 4px #000000",
            width: "100%",
            left: "0",
            right: "0",
            textAlign: "center",
          }}
        >
          <div style={{display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center', width:'fit-content', margin:'auto', gap:'25px', minHeight:'200px'}}>
            <div>
          <img className="west22-logo" loading="eager" style={{maxWidth:'600px'}} 
          // src={"./assets/events/west22/west22_logo.png"} 
          src={'./assets/media/Group 144.png'}
          /></div>
          <Stack spacing={1}>
            <h4 style={{fontSize: window.innerWidth < 769 && "1rem"}}>July 19th - 20th 2022</h4>
            <h4 style={{fontSize: window.innerWidth < 769 && "1rem"}}>Silicon Valley</h4>
            </Stack>
          </div>
        </span> */}

         </Container>

         <div id='investor-section'>
            <Investors />
         </div>
         <VideoSection finishedLoading={finishedLoading} />
         <RegisterCards />
         {window.innerWidth > 900 && <LogoCarouselNew />}
         <TracksWeb />
         <NominateCards />
         {window.innerWidth > 900 && <TestimonialCarouselNew />}
         <SponsorSectionTest />
         <FooterFinal />
      </div>
   );
};
